import { Controller } from 'stimulus';

class OrderListModalController extends Controller {
  onShowModal() {
    $(this.element).find('.modal').modal('show');

    if (!this.hasVideoContainerTarget) {
      return;
    }

    const iframe = this.videoContainerTarget.querySelector('iframe');
    const videoUrl = this.videoContainerTarget.getAttribute('data-video-src');

    if (!iframe || !videoUrl) {
      return;
    }

    iframe.src = videoUrl;
  }

  onHideModal() {
    $(this.element).find('.modal').modal('hide');

    if (!this.hasVideoContainerTarget) {
      return;
    }

    const iframe = this.videoContainerTarget.querySelector('iframe');

    iframe.src = '';
  }
}

OrderListModalController.targets = ['videoContainer'];

export default OrderListModalController;
